import React, { memo } from "react";
import { Stack, Button } from "@mui/material";

import RookiePacketTable from "../RookiePacketTable/RookiePacketTable";
import HexDisplay from "../HexDisplay/HexDisplay";

import "./M3RookieSection.scss";

const M3RookieSection = ({
  packets,
  marker,
  checkFunction,
  onPacketSelect,
  selectedPacket,
  isLoading,
}) => {
  return (
    <Stack className="rookie-panel" gap={2}>
      <Stack useFlexGap={1} className="map-area" gap={2}>
        <RookiePacketTable
          level="rookie"
          packets={packets}
          selectedPacket={selectedPacket}
          handlePacketSelect={onPacketSelect}
        />
        <Stack className="hex-section">
          <HexDisplay selectedPacket={selectedPacket} />
        </Stack>
      </Stack>

      <Stack className="wrapper">
        <Button
          variant="contained"
          disabled={!marker || Object.keys(marker).length === 0 || isLoading}
          onClick={checkFunction}
          className={`btn button ${(!marker || isLoading) && "disabled"}`}
        >
          {isLoading ? "Checking..." : "Check"}
        </Button>
      </Stack>
    </Stack>
  );
};

export default memo(M3RookieSection);
